import { OrderByEnum, ProviderSortColumnEnum } from './requests';

export enum ProviderStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export type Provider = {
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  npi: string;
  tin: string;
  taxId: string;
  isDefault?: boolean;
  isPayerDefault?: boolean;
  status?: ProviderStatus;
  payers?: number[];
};

export type ProviderWithPayerDefaults = {
  id: number;
  firstName: string;
  lastName: string;
  npi: string;
  taxId: string;
  payerDefaultProviders?: {
    payerId: number;
  }[];
};

export type ProviderSortFilters = {
  sortBy?: ProviderSortColumnEnum;
  orderBy?: OrderByEnum;
};
